import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { Sponsor } from '@repo/types';
import API from '../endpoints';
import { getAccessToken } from '../utils/getAccessToken';

// 30 minutes frontend cache for sponsor list query
const CACHE_TIME = 30 * 60 * 1000;

export const useSponsorsQuery = () => {
  return useQuery({
    queryKey: ['sponsors'],
    queryFn: fetchSponsors,
    staleTime: !getAccessToken() ? CACHE_TIME : undefined,
  });
};

const fetchSponsors: QueryFunction<Sponsor[], [string]> = async () => {
  const accessToken = getAccessToken();
  const { data } = await axios.get<Sponsor[]>(API.endpoints.sponsors, {
    headers: accessToken
      ? {
          Authorization: `Bearer ${accessToken}`,
        }
      : {},
  });
  return data;
};
